<template>
  <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
    <div class="panel panel-default" v-for="(filter, index) in nonCollectionFilterOptions" :key="index">
      <div class="panel-heading" role="tab">
        <h4 class="panel-title">
          <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" :href="'#' + index"
            aria-expanded="false" aria-controls="">
            {{ filter.name }}
          </a>
        </h4>
      </div>
      <div :id="index" class="panel-collapse collapse" role="tabpanel">
        <div class="panel-body" v-for="(filterItem, index) in filter.sub_categories" :key="index" v-show="filterItem.enabled">
          <input type="checkbox" :id="filter.name + '_' + index" @change="toggle(filterItem, filter)"
            v-model="filterItem.selected" />

          <label :for="filter.name + '_' + index">{{ filterItem.name }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
* @file ItemFilters.vue
* @summary displays the list of accordion filter options (gloss levels, finishes, etc.).
* @displayName Item Filters
*/
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'item-filters',

  computed: {
    ...mapGetters([
      'filterOptions'
    ]),

    nonCollectionFilterOptions() {
      return Object.values(this.filterOptions).filter(item => item.code !== 'pris_collections' && item.enabled === true);
    }
  },

  methods: {
    ...mapActions([
      'toggleFilterOption'
    ]),

    toggle(clickedFilter, filterParent) {
      this.toggleFilterOption({ clickedFilter, filterParent });
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-default {
  border-color: #bdbdbd;
}

.panel-group .panel {

  .panel-heading {
    background-color: #fff;
    color: #222;
  }

  .panel-body {
    padding: 10px 15px;

    label {
      font-weight: 600;
      margin: 0;
    }
  }
}
</style>